import React, { useEffect, useState } from "react";

const endOfDay = () => { const d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime(); };
const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

export const AnnouncementBar = () => {
  const [left, setLeft] = useState(endOfDay() - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(endOfDay() - Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const h = Math.floor(left / 3.6e6);
  const m = Math.floor((left % 3.6e6) / 6e4);
  const s = Math.floor((left % 6e4) / 1000);

  const items = [
    "FREE SHIPPING OVER $360 + FREE HAT",
    "SUMMER '26 CAPSULE — NOW LIVE",
    "SHOP THE FULL SET",
    `FREE SHIPPING ENDS IN ${pad(h)}:${pad(m)}:${pad(s)}`,
    "EXCLUSIVE DROPS ONLY",
  ];

  const Track = ({ ariaHidden }) => (
    <div className="marquee__track" aria-hidden={ariaHidden}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center gap-12">
          <span className="overline text-[11px]">{t}</span>
          <span className="text-white/35 text-[11px]">/</span>
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="announcement-bar" className="bg-[#0A0A0A] text-[#F4F2ED] py-2.5 marquee">
      <Track />
      <Track ariaHidden />
    </div>
  );
};
